import React, { FC } from "react";
import { EventDataMessageType } from "@app/pippa/models";
import BubbleTail from "@app/pippa/components/bubbleTail";
import { useMarkdownToHtml } from "@app/pippa/hooks";
import { AvatarLogo } from "@app/pippa/components/message";
import AIAssistant from "@app/pippa/assets/ai-assistant.png";
import "./streamingMessage.scss";

const CURSOR_HTML = '<span class="streaming-message__blinking-cursor" />';
const TRAILING_CLOSE_TAGS = /(\s*<\/[a-z][a-z0-9]*>)+\s*$/i;

const injectCursorHtml = (html: string): string => {
  const match = html.match(TRAILING_CLOSE_TAGS);

  if (match?.index) {
    return html.slice(0, match.index) + CURSOR_HTML + html.slice(match.index);
  }

  return html + CURSOR_HTML;
};

interface Props {
  message: EventDataMessageType;
  isShowLogo: boolean;
}

const StreamingMessage: FC<Props> = ({ message, isShowLogo }) => {
  const htmlContent = useMarkdownToHtml(message.text);

  return (
    <div className="message-body__container">
      {isShowLogo && <AvatarLogo logoSrc={AIAssistant} />}
      <div className="text-message__wrapper pippa-text-message__wrapper">
        <div className="text-message__bubble text-message__with-logo">
          <div
            className="text-message__text raw-text"
            dangerouslySetInnerHTML={{
              __html: injectCursorHtml(htmlContent),
            }}
          />
        </div>
        <BubbleTail isShowAvatar={isShowLogo} isSendByUser={false} />
      </div>
    </div>
  );
};

export default StreamingMessage;
